module.exports = __webpack_public_path__ + "static/media/twitter.bbad08c3.png";


//////////////////
// WEBPACK FOOTER
// ./client/socialMediaLogos/twitter.png
// module id = 474
// module chunks = 0